
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/edition/[editionId]",
      function () {
        return require("private-next-pages/categories/edition/[editionId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categories/edition/[editionId]"])
      });
    }
  